var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from "react";
import { Row, Grid } from "react-bootstrap";
import withBranding from "@irati/brand/withBranding";
import { SideBar, MainSection } from "../components/UserOnboarding";
import { BackGround, Col } from "./styled";
var OnboardContainer = /** @class */ (function (_super) {
    __extends(OnboardContainer, _super);
    function OnboardContainer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    OnboardContainer.prototype.render = function () {
        var color = this.props.branding.primaryColour;
        var maxHeight = { height: "100%" };
        return (React.createElement(BackGround, { color: color },
            React.createElement(Grid, { style: maxHeight },
                React.createElement(Row, { style: maxHeight },
                    React.createElement(Col, { md: 7, style: maxHeight },
                        React.createElement(MainSection, null, this.props.children)),
                    React.createElement(Col, { smHidden: true, xsHidden: true },
                        React.createElement(SideBar, null))))));
    };
    return OnboardContainer;
}(Component));
export default withBranding(OnboardContainer);
